export default __webpack_public_path__ + "static/media/e-ks-logotype-l.6ff0f103.svg";